import React, { useEffect, useState } from "react";
import "./Login.css";
import logo from "../../assets/logo-main.svg";
import googleLogo from "../../assets/google-logo.svg";
import FAHelp from "../../assets/2FAHelp.png";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { toast } from "react-toastify";
import useMyStore from "../../Global";
import { API } from "../../assets/staticData";

function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [inputError, setInputError] = useState({ a: false, b: false });
  const [forgotPassLayout, setforgotPassLayout] = useState(false);
  const [twoFALayout, setTwoFALayout] = useState(false);

  const setUserLoggedIn = useMyStore((state) => state.setUserLoggedIn);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Login the user
  const loginUser = () => {
    if (identifier == "") {
      setInputError({ ...inputError, a: true });
      toast("Please fill in the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    } else if (password == "") {
      setInputError({ ...inputError, b: true });
      toast("Please fill in the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    } else {
      fetch(`${API}/auth/local`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          identifier: identifier,
          password: password,
        }),
      })
        .then(async (res) => {
          const respone = await res.json();
          console.log(respone);
          if (respone?.jwt) {
            //  setTwoFALayout(true);

            localStorage.setItem("userToken", respone.jwt);
            // setUserLoggedIn(true);
            window.location.reload();
          } else {
            setInputError({ ...inputError, a: true, b: true });
            toast("Invalid Credentials, Check again please", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // Login the user viua Google
  const loginViaGoogle = async () => {
    fetch("http://localhost:1337/strapi-google-auth/init", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }).then(async (res) => {
      const respone = await res.json();
      window.open(respone?.url, "newWindow", "width=700 , height=600");
    });
  };

  // Reset Password
  const resetPassword = () => {
    if (identifier !== "") {
      fetch(`${API}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: identifier,
        }),
      })
        .then(async (res) => {
          if (!res.ok) {
            const errorData = await res.json();
            toast("Invalid Email Address", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "error",
            });
          } else {
            toast("Password reset link was sent to your email address", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setInputError({ ...inputError, a: true });
    }
  };

  return (
    <div className="loginO">
      <div className="bottomBG"></div>
      <div className="loginC">
        {forgotPassLayout ? (
          <div className="side fadeIn">
            <div className="inputC">
              <h3>Forgot Password</h3>
              <TextField
                error={inputError.a}
                className="loginInput"
                label="Email Address"
                variant="outlined"
                style={{ marginBottom: 10 }}
                value={identifier}
                onChange={(e) => {
                  setIdentifier(e.target.value);
                  setInputError({ ...inputError, a: false });
                }}
              />

              <p onClick={() => setforgotPassLayout(false)}>Go back lo login</p>

              <div className="loginBTN" onClick={resetPassword}>
                Send Password Reset Link
              </div>
            </div>
          </div>
        ) : (
          <div className="side fadeIn">
            <div className="inputC">
              <h3>Login</h3>
              <TextField
                error={inputError.a}
                className="loginInput"
                label="Email or Username"
                variant="outlined"
                style={{ marginBottom: 10 }}
                value={identifier}
                onChange={(e) => {
                  setIdentifier(e.target.value);
                  setInputError({ ...inputError, a: false });
                }}
              />
              <FormControl
                className="loginInput"
                sx={{ m: 1 }}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>
                <OutlinedInput
                  error={inputError.b}
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setInputError({ ...inputError, b: false });
                  }}
                />
              </FormControl>
              <p onClick={() => setforgotPassLayout(true)}>Forgot Password?</p>

              <div className="loginBTN" onClick={loginUser}>
                Login
              </div>

              {/* <div className="googleLoginBTN" onClick={loginViaGoogle}>
                <img src={googleLogo} />
                Login via Google
              </div> */}
            </div>
          </div>
        )}
        <div className="side colored">
          <div
            style={{ backgroundColor: "#fff", padding: 25, borderRadius: 15 }}
          >
            <img src={logo} className="loginLogo fadeInFast" />
          </div>
        </div>
      </div>
      {twoFALayout && (
        <div className="towFAOverLay">
          <div className="twoFAC fadeIn">
            <h2 style={{ fontSize: 30 }}>Two-factor Authentication</h2>
            <p style={{ textAlign: "center", color: "#777" }}>
              Enter the authentication code from your mobile app <br /> to
              verify your identity.
            </p>
            <div className="faInputC">
              <img src={FAHelp} style={{ width: 75 }} />
              <div>
                <p style={{ fontSize: 14, marginBottom: 5, color: "#666" }}>
                  Authentication Code
                </p>
                <TextField
                  label="Code"
                  id="outlined-size-small"
                  size="small"
                  placeholder="6-digit code"
                />
              </div>
            </div>
            <div className="loginBTN" style={{ marginTop: 20, width: "52%" }}>
              Submit
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;
